"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.CircleIconContainer = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _templateObject, _templateObject2;
var StyledIcon = exports.StyledIcon = (0, _styledComponents["default"])(_reactFontawesome.FontAwesomeIcon)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  font-weight: 900;\n  font-size: 13px;\n"])));
var CircleIconContainer = exports.CircleIconContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 38px;\n  height: 38px;\n  border: 2px solid #ffffff;\n  border-radius: 50%;\n  background: ", ";\n  color: ", ";\n\n  :hover {\n    background-color: ", "!important;\n    color: ", ";\n  }\n"])), function (_ref) {
  var hasSpeakers = _ref.hasSpeakers;
  return hasSpeakers ? '#ffffff' : 'rgba(0, 0, 0, 0.25)';
}, function (_ref2) {
  var hasSpeakers = _ref2.hasSpeakers;
  return hasSpeakers ? '#6E7582' : '#ffffff';
}, function (_ref3) {
  var hasSpeakers = _ref3.hasSpeakers;
  return hasSpeakers ? 'rgba(0, 0, 0, 0.25)' : '#ffffff';
}, function (_ref4) {
  var hasSpeakers = _ref4.hasSpeakers;
  return hasSpeakers ? '#ffffff' : '#6E7582';
});